import { SpreadsheetActions } from "@/components/tickets/SpreadsheetPreviewDialog";
import { spreadsheetKind } from "@/lib/spreadsheetPreview";
import { AudioAttachmentPlayer } from "@/components/tickets/AudioAttachmentPlayer";
import type { TicketAttachmentRef } from "@/services/ticket";

export function isStaffAudioAttachment(a: TicketAttachmentRef): boolean {
  if (a.mimeType?.startsWith("audio/")) return true;
  return /\.(webm|mp3|wav|m4a|ogg|opus|aac)$/i.test(a.name || "");
}

export function StaffMessageAttachments({
  items,
}: {
  items: TicketAttachmentRef[];
}) {
  if (!items?.length) return null;
  return (
    <div className="mt-2 space-y-2">
      {items.map((a, i) => {
        const isAudio = isStaffAudioAttachment(a);
        return (
          <div key={`${a.url}-${i}`} className="rounded-lg border border-border/50 bg-card/30 p-2 text-xs break-all">
            {a.mimeType?.startsWith("image/") ? (
              <>
                <p className="mb-1 font-medium">{a.name}</p>
                <a href={a.url} target="_blank" rel="noreferrer" className="block">
                  <img src={a.url} alt={a.name} className="max-h-48 rounded object-contain" />
                </a>
              </>
            ) : isAudio ? (
              <div className="space-y-2">
                <AudioAttachmentPlayer src={a.url} label={a.name} compact />
                {a.transcript ? (
                  <div className="rounded-md border border-border/40 bg-muted/20 px-2 py-1.5">
                    <p className="text-xs whitespace-pre-wrap text-muted-foreground leading-relaxed">
                      {a.transcript}
                    </p>
                  </div>
                ) : null}
              </div>
            ) : a.mimeType?.startsWith("video/") ? (
              <>
                <p className="mb-1 font-medium">{a.name}</p>
                <video controls src={a.url} className="max-h-64 w-full rounded" />
              </>
            ) : spreadsheetKind(a) ? (
              <>
                <p className="mb-1 font-medium">{a.name}</p>
                <SpreadsheetActions attachment={a} className="flex gap-2" />
              </>
            ) : (
              <>
                <p className="mb-1 font-medium">{a.name}</p>
                <a href={a.url} target="_blank" rel="noreferrer" className="text-primary underline">
                  Abrir arquivo
                </a>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
